module.exports = __webpack_public_path__ + "asset/image-ic_category_24-fd10465c9d013371.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_24.svg
// module id = GskU
// module chunks = 0